/* unplugin-vue-components disabled */import { render } from "./RecommendVideo.vue?vue&type=template&id=25f85699&scoped=true"
import script from "./RecommendVideo.vue?vue&type=script&lang=js"
export * from "./RecommendVideo.vue?vue&type=script&lang=js"

import "./RecommendVideo.vue?vue&type=style&index=0&id=25f85699&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f85699"]])

export default __exports__